import { Configuration } from '@azure/msal-browser';

export const appConfig = {
  scopes: [B2C_SCOPE],
};

export const msalConfig: Configuration = {
  auth: {
    clientId: B2C_CLIENT_ID,
    authority: B2C_AUTHORITY,
    knownAuthorities: [B2C_KNOWN_AUTHORITY],
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};
